import React from "react";
import "./styles.css";
import {
  MDBCarousel,
  MDBCarouselInner,
  MDBCarouselItem,
  MDBView,
  MDBContainer,
} from "mdbreact";
import SLIDES from "../../../data/carousel";

const Carousel = () => {
  return (
    <>
      <MDBContainer fluid className="carousel-container">
        <MDBCarousel
          activeItem={1}
          length={SLIDES.length}
          showControls={true}
          showIndicators={true}
          interval={6000}
        >
          <MDBCarouselInner>
            {SLIDES.map((url, key) => (
              <MDBCarouselItem itemId={key + 1} key={key}>
                <MDBView>
                  <div
                    className="carousel-img"
                    style={{
                      backgroundImage: `url('${url.image}')`,
                    }}
                  />
                </MDBView>
              </MDBCarouselItem>
            ))}
          </MDBCarouselInner>
        </MDBCarousel>
      </MDBContainer>
    </>
  );
};

export default Carousel;
